import { useQuery } from 'jsonapi-react';
import { createContext, type ReactNode, useContext } from 'react';

import { type MealCategory } from '../entities';

import { type DataContext } from '../types';

export const mealCategoriesContext = createContext<DataContext<MealCategory[]>>({
  data: [],
  isLoading: false,
  isFetching: false,
  refetch: () => {},
});

export const MealCategoriesProvider = ({ children }: { children: ReactNode }): ReactNode => {
  const mealCategories = useQuery<MealCategory[]>([
    'meal-category',
    {
      sort: 'sortOrder',
      page: { limit: 10000 },
      fields: { 'meal-category': ['name'] },
    },
  ]);

  return (
    <mealCategoriesContext.Provider value={mealCategories}>
      {children}
    </mealCategoriesContext.Provider>
  );
};
export const useMealCategories = (): DataContext<MealCategory[]> =>
  useContext(mealCategoriesContext);
